import React, { useEffect, useState } from 'react';
import { Trans } from '@common/i18n/trans';
import { Link } from 'react-router-dom';
import { TextField } from '@common/ui/forms/input-field/text-field/text-field';
import { Button } from '@common/ui/buttons/button';
import styles from './TemplateGrid.module.css';

interface TemplateGridProps {
  templates: Array<{
    id: string;
    name: string;
    thumbnail: string;
    category?: string;
  }>;
  loading: boolean;
  onSelectTemplate: (template: string) => void;
  selectedTemplate: string | 'blank' | null;
  proceedToFinalStep: () => void;
  categories: string[];
}

export function TemplateGrid({
  templates,
  loading,
  onSelectTemplate,
  selectedTemplate,
  proceedToFinalStep,
  categories,
}: TemplateGridProps) {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState<string>('');
  const [filteredTemplates, setFilteredTemplates] = useState(templates);

  useEffect(() => {
    const filtered = templates.filter(
      (template) =>
        template.name.toLowerCase().includes(searchQuery.toLowerCase()) &&
        (selectedCategory ? template.category === selectedCategory : true)
    );
    setFilteredTemplates(filtered);
  }, [searchQuery, selectedCategory, templates]);

  return (
    <div className={styles.templateSelectionContainer}>
      {/* Sidebar for Search and Categories
      <div className={styles.templateSelectionSidebar}>
        <TextField
          placeholder="Search templates..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className={styles.templateSearchBar}
        />
        <div className={styles.templateCategoryList}>
          <h4>Categories</h4>
          <ul>
            <li
              className={!selectedCategory ? styles.activeCategory : ''}
              onClick={() => setSelectedCategory('')}
            >
              <Trans message="All" />
            </li>
            {categories.map((category) => (
              <li
                key={category}
                className={selectedCategory === category ? styles.activeCategory : ''}
                onClick={() => setSelectedCategory(category)}
              >
                <Trans message={category} />
              </li>
            ))}
          </ul>
        </div>
      </div> */}

      {/* Grid of Templates */}
      <div className={styles.templateSelectionGrid}>
        {loading ? (
          <div className={styles.loadingMessage}>
            <Trans message="Loading templates..." />
          </div>
        ) : filteredTemplates.length ? (
          filteredTemplates.map((template) => (
            <div
              key={template.id}
              className={`${styles.templateCard} ${
                selectedTemplate === template.name ? styles.selected : ''
              }`}
            >
              {/* Wrap image in a Link */}
              <Link to={`/dashboard/templates/${template.name}`}>
                <img
                  className={styles.templateImage}
                  src={template.thumbnail}
                  alt={template.name}
                />
              </Link>
              {selectedTemplate === template.name && (
                <div className={styles.selectedBadge}>
                  <Trans message="Selected" />
                </div>
              )}
              <div className={styles.templateDetails}>
                <h3 className={styles.templateTitle}>{template.name}</h3>
              </div>
              <div className={styles.templateActions}>
                <Button
                  onClick={() => onSelectTemplate(template.name)}
                  variant="flat"
                  color="primary"
                >
                  <Trans message="Select" />
                </Button>
                <Link to={`/dashboard/templates/${template.name}`}>
                  <Button variant="text">
                    <Trans message="Preview" />
                  </Button>
                </Link>
              </div>
            </div>
          ))
        ) : (
          <div className={styles.noResultsMessage}>
            <Trans message="No templates found." />
          </div>
        )}
      </div>
    </div>
  );
}
